//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	// import open from '@/assets/js/openWin'
	// import rankList from '@/components/donateTogether/rankList'
	import headerBackTitleShare from '@/components/header/headerBackTitleShare'
	let Base64 = require('js-base64').Base64
	export default {
		data() {
			return {
				imgUrl:require('../assets/images/fpw_logo_small.png'),
				orgName: this.$route.params.orgName,
				groupDonationId: this.$route.params.dtId,
				epId: this.$route.params.epId,
				acr001: this.$route.params.acr001,
				rankType: [{id: 1, name: '按时间'}, {id: 2, name: '按金额'}],
				typeBoolean: false,
				isTab: true,
				sortIndex: 0,
				timeList: [],
				moneyList: [],
				shareInfo: {},
				timeIndex:1,
				moneyIndex:1,
				listTotal:'',
				imgShareUrl:require('../assets/images/rankShare.png')
			}
		},
		components: {
			// rankList,
			headerBackTitleShare
		},
		methods: {
			donateMoney(donateNum) {
				if(donateNum>=1000000){
					let divide = donateNum/10000
					return divide.toFixed(3).slice(0,-1)
				}else{
					return donateNum
				}
			},
			base64(name) {
				return Base64.decode(name.substring(11))
			},
			getHeadth (head) {
	      return head.includes("zgshfp.oos-website-cn")?head:this.zc_userhead+head
	    },
	    getNickName(nickName) {
	    	if (nickName) {
	    		return nickName.includes("WX_NICKNAME")?this.base64(nickName):nickName
	    	}else{
	    		return '爱心人士'
	    	}
	    },
			tab(index) {
				// 员工排行类型切换
				if(this.sortIndex !== index) {
					this.sortIndex = index
					this.typeBoolean = !this.typeBoolean
					if(this.isTab) {
						this.isTab = false
						this.getStaffRank()
					}
				}
			},
			refresh (done) {
		  	setTimeout(() => {
			   	// this.pageIndex = 1
			   	if(this.sortIndex == 0){
			   		this.timeIndex = 1
			   		this.timeList = []
			   	}else {
			   		this.moneyList = []
			   		this.moneyIndex = 1
			   	}
			 		this.getStaffRank();
			 		done()
		  	}, 1000)
		  },
		  infinite (done) {
		 		setTimeout(() => {
		 			if(this.sortIndex == 0){
				   		if(this.timeList.length < this.listTotal) {
				   			this.timeIndex++
				 				this.getStaffRank(done);
				   		}else {
				   			done(true)
				   		}
				   	}else {
				   		if(this.moneyList.length < this.listTotal) {
				   			this.moneyIndex++
				 				this.getStaffRank(done);
				   		}else {
				   			done(true)
				   		}
				   	}

		 		}, 1000)
		 	},
			getStaffRank(done) {
				// 员工排行榜
				let data={
	        groupdonationId: this.groupDonationId,
	        epId: this.epId,
	        sort: this.sortIndex + 1,
	        blcSign: this.DT_QKL,
	        pageIndex:this.sortIndex == 0 ? this.timeIndex:this.moneyIndex,
	        pageSize:10
	      }
        this.$https.post(this.BASE_URL+"grd/groupDonation/listOfUserByGroupDonationID",
          data
        )
        .then(res => {
        	if(res.data.code == "GRDI0000"){
	        	this.wechatshareneedkey()
	        	this.listTotal = res.data.data.total
	        	if(this.sortIndex == 0) {
	        		this.timeList.push(...res.data.data.data)
	        	}else if(this.sortIndex == 1) {
	        		this.moneyList.push(...res.data.data.data)
	        	}
	        	if(done){
	         		done(true)
	         	}
        	}
        })
        .catch(function(err) {
        	console.log(err);
        })
			},
       formatDate(now) {
    var year=now.getFullYear();
    var month=now.getMonth()+1;
    var date=now.getDate();
    var hour=now.getHours();
    var minute=now.getMinutes();
    var second=now.getSeconds();
    return year+"-"+month+"-"+date;
  },
  wechatshareneedkey () {
	   		if(this.isWeixinCient()){
	   			let lineLink=window.location.href.split('#')[0];//要分享页面的地址，即该页面地址
	   			this.shareInfo = {
		        title : '社会帮扶，让爱在阳光下连接~ ',
		        desc: '参与一起捐，播撒爱心，点燃希望~',
		        link : this.appjump_url+'/pages/index/#/dTRankStaff/'+encodeURIComponent(this.orgName)+'/'+this.groupDonationId+'/'+this.epId+'/'+this.acr001+"?isSingle=single",
		        imgUrl: this.appjump_url+'/pages/index/shareIcon/rankShare.png'
			    };
			    this.setWeixinConfig(this.shareInfo);
	   		}else{
	   			let title = '社会帮扶，让爱在阳光下连接~'
	   			let desc = '参与一起捐，播撒爱心，点燃希望~'
	   			this.shareInfo = '{"picurl":"'+this.appjump_url+'/pages/index/shareIcon/rankShare.png","title":"'+title+'","type":"'+2+'","projectId":"'+this.acr001+'","text":"'+desc+'","url":"'+this.appjump_url+'/pages/index/#/dTRankStaff/'+encodeURIComponent(this.orgName)+'/'+this.groupDonationId+'/'+this.epId+'/'+this.acr001+'?isSingle=single","ischange":'+'"2"'+'}'
	   			console.log(this.shareInfo)
	   		}
   		},
			goQKL (data) {
	      if(this.isWeixinCient()){
					window.location.href=data
				}else{
					console.log('{"title":"扶贫区块链","url":"'+data+'&platform=app","navbarHidden":"YES"}');
					window.navigation.pushPage('{"title":"扶贫区块链","url":"'+data+'&platform=app","navbarHidden":"YES"}')
				}
	    },
	    timenew(loveTime) {
      	let loTime = this.getDateTimeStamp(loveTime);
      	let minute = 1000 * 60;
        let hour = minute * 60;
        let day = hour * 24;
        let halfamonth = day * 15;
        let month = day * 30;
        let now = new Date().getTime();
        let diffValue = now - loTime;
        if(diffValue < 0){return;}
        let monthC =diffValue/month;
        let weekC =diffValue/(7*day);
        let dayC =diffValue/day;
        let hourC =diffValue/hour;
        let minC =diffValue/minute;
        let time = new Date(loTime);
        if(dayC>1&&monthC<=1){
            loTime=""+ parseInt(dayC) +"天前";
        }
        else if(hourC>=1&&dayC<1){
            loTime=""+ parseInt(hourC) +"小时前";
        }
        else if(minC>=1&&hourC<1){
            loTime=""+ parseInt(minC) +"分钟前";
        }else if(minC<1){
            loTime="刚刚";
        }else{
            loTime= this.formatDate(time)
        }
        return loTime
    	},
    	getDateTimeStamp (dateStr) {
        return Date.parse(dateStr.replace(/-/gi,"/"));
    	}
		},
		created() {
			this.getStaffRank()
		},
		mounted() {
			if(this.$route.query.isSingle == "single") {
				let headback = document.getElementsByClassName('left-arrow')[0]
				let ua = navigator.userAgent.toLowerCase();
				headback.style.display = "none"
			}
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/dTRankStaff.vue